module.exports = __webpack_public_path__ + "static/we-ride-upon-sticks-e8ac63c9bc65918f3f1af45237b4586f.jpg";